import { LanguageEnum, LanguageProps } from "./language.props";

const languageReducers = (
  state: LanguageProps,
  action: { type: LanguageEnum; payload: any }
) => {
  switch (action.type) {
    case LanguageEnum.SET:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default languageReducers;
